export interface StakeholderRequest {
  id: number
  group: {
    id: string
    name: string
    slug: string
    type: string
  }
  createdAt: string
  description: string
  createdBy: string
  completedStatus: boolean
  isRejected: boolean
  rejectionReason?: string
}

export interface StakeholderLimit {
  id: number
  createdAt: string
  createdBy: string
  group: {
    id: string
    name: string
    slug: string
    type: string
  }
  isRejected: boolean
  completedStatus: boolean
  newLimit: {
    subsription: number
    request: number
  }
}

export enum ActiveLabelType {
  report,
  limit,
}
export enum RequestType {
  limitRequest = 'limitRequest',
  shareRequest = 'shareRequest',
}

export interface RejectRequestPayload {
  type: RequestType
  reason?: string
}
